import React, {useContext, useEffect, useRef} from 'react';
// import {widgetCheck, widgetFace} from '../../../assets/images/images';
import {
  disclaimerPageDefaultInfo as defaultInformation,
  toggleStringConversion,
} from '../widgetHelpers';
import {EasyOnboardContext} from '../../../helpers/context';
import {useSelector} from 'react-redux';
import {Loader} from '../../../components';

const ConfigDisclaimer = () => {
  const {w_loading} = useSelector(state => state?.widgets);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    }
  });

  const {widgetData} = useContext(EasyOnboardContext);
  const instructions =
    widgetData?.index_instructions ||
    toggleStringConversion(defaultInformation);

  const getBreakClass = text => {
    const words = text?.split(/\s+/);
    const hasLongWord = words?.some(word => word?.length > 15);
    return hasLongWord ? 'break-all' : 'break-words';
  };

  return (
    <>
      <header className="mt-9">
        <div className="flex items-center justify-center">
          <svg
            width="58"
            height="57"
            viewBox="0 0 58 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1"
              y="0.5"
              width="56"
              height="56"
              rx="28"
              fill="var(--color-primary)"
            />
            <rect
              x="1"
              y="0.5"
              width="56"
              height="56"
              rx="28"
              fill="white"
              fillOpacity="0.9"
            />
            <rect
              x="1"
              y="0.5"
              width="56"
              height="56"
              rx="28"
              stroke="var(--color-primary)"
            />
            <path
              d="M37.0833 26.4998L38.2854 27.2211C38.5221 27.3632 38.5989 27.6703 38.4569 27.9071C38.4146 27.9774 38.3557 28.0363 38.2854 28.0786L28.9999 33.6498L19.7145 28.0786C19.4777 27.9365 19.4009 27.6294 19.543 27.3926C19.5852 27.3222 19.6441 27.2633 19.7145 27.2211L20.9166 26.4998L28.9999 31.3498L37.0833 26.4998ZM37.0833 31.1998L38.2854 31.9211C38.5221 32.0632 38.5989 32.3703 38.4569 32.6071C38.4146 32.6774 38.3557 32.7363 38.2854 32.7786L29.5144 38.0411C29.1977 38.2311 28.8021 38.2311 28.4854 38.0411L19.7145 32.7786C19.4777 32.6365 19.4009 32.3294 19.543 32.0926C19.5852 32.0222 19.6441 31.9633 19.7145 31.9211L20.9166 31.1998L28.9999 36.0498L37.0833 31.1998ZM29.5144 17.3085L38.2854 22.5711C38.5221 22.7132 38.5989 23.0203 38.4569 23.2571C38.4146 23.3275 38.3557 23.3864 38.2854 23.4286L28.9999 28.9998L19.7145 23.4286C19.4777 23.2865 19.4009 22.9794 19.543 22.7426C19.5852 22.6722 19.6441 22.6133 19.7145 22.5711L28.4854 17.3085C28.8021 17.1185 29.1977 17.1185 29.5144 17.3085Z"
              fill="var(--color-primary)"
            />
          </svg>
        </div>
      </header>
      <div className="max-w-sm   px-6">
        {w_loading || initialRender?.current ? (
          <div className="p-6 mt-8 w-[332px] border rounded-lg bg-[#EBF1FC] border-brandBlue60 min-h-[150px] transition-all ease-in-out delay-150 ">
            <Loader height={initialRender?.current ? 9 : 16} />
          </div>
        ) : (
          <div className="p-6 mt-8 rounded-lg bg-[#F9F9F9] min-h-[200px] transition-all ease-in-out delay-150 ">
            <p className="font-medium text-tiny text-[#080917]">
              Please note the following
            </p>
            {instructions?.map((line, index) => (
              <div
                key={index}
                className={`flex items-start gap-3 mt-4 max-w-[98%] ${getBreakClass(
                  line,
                )}`}
              >
                <svg
                  className="min-w-4 min-h-4"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_10895_87917)">
                    <path
                      d="M8.00004 14.6666C4.31804 14.6666 1.33337 11.682 1.33337 7.99998C1.33337 4.31798 4.31804 1.33331 8.00004 1.33331C11.682 1.33331 14.6667 4.31798 14.6667 7.99998C14.6667 11.682 11.682 14.6666 8.00004 14.6666ZM7.33537 10.6666L12.0487 5.95265L11.106 5.00998L7.33537 8.78131L5.44937 6.89531L4.50671 7.83798L7.33537 10.6666Z"
                      fill="var(--brand-color)"
                      style={{fill: 'var(--color-primary)', fillOpacity: 1}}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_10895_87917">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        style={{fill: 'white', fillOpacity: 1}}
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className="text-small text-[#4A4A68] -mt-[2px]">{line}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(ConfigDisclaimer);
